import Swiper, { Navigation } from "swiper";

class ReadSlider {
	private tabs: HTMLElement[];
	private currentTabIndex: number = 0;

	private desktopInstance: Swiper;
	private mobInstance: Swiper;
	private readonly sliderContainer: HTMLElement;
	private readonly sliderMobContainer: HTMLElement;

	constructor() {
		this.sliderContainer = document.querySelector(".read--slide--slider");
		this.sliderMobContainer = document.querySelector(".read--slider--mob");

		if (this.sliderContainer && this.sliderMobContainer) {
			this.initSliders();
			setTimeout(() => {
				this.initTabs();
			}, 200)
		}
	}

	initTabs() {
		this.tabs = Array.from(document.querySelectorAll(".read--menu__item"));
		this.tabs.forEach((tab, index) => {
			tab.addEventListener("click", () => {
				this.setTab(index)
				let setSlide = false;
				const slides = this.desktopInstance.slides.length > 0 ? this.desktopInstance.slides : this.mobInstance.slides;
				slides.forEach((item, slideIndex) => {
					const element = item as HTMLElement;
					console.log(index, Number(element.dataset.tabIndex))
					if (Number(element.dataset.tabIndex) == index && !setSlide) {
						if (this.desktopInstance.slides.length > 0) {
							this.desktopInstance.slideTo(slideIndex)
						}
						if (this.mobInstance.slides.length > 0) {
							this.mobInstance.slideTo(slideIndex)
						}
						setSlide = true;
					}
				})
			})
		})
	}

	setTab(index) {
		this.tabs.forEach(i => i.classList.remove("_active"))
		const currentTab = this.tabs[index];
		currentTab.classList.add("_active")
		this.currentTabIndex = index;
	}

	initSliders() {

		this.desktopInstance = new Swiper(this.sliderContainer, {
			modules: [Navigation],
			loop: false,
			slidesPerView: 3,
			spaceBetween: 5,
			navigation: {
				nextEl: document.querySelector(".read--slide--wrapper .read--slider-btn__next") as HTMLElement,
				prevEl: document.querySelector(".read--slide--wrapper .read--slider-btn__prev") as HTMLElement
			},
			on: {
				afterInit: function () {
					if (window.outerWidth >= 1151) {
						let currentSlide;
						currentSlide = document.querySelector("#read .swiper-slide.swiper-slide-next");
						const backgroundImgCurrent = document.querySelector(".read--background__img_" + currentSlide.dataset.slideId);
						backgroundImgCurrent?.classList.add("_active");
					}
				},
				slideChange: function () {
					const nextSlide = this.slides[this.activeIndex + 1];
					const backgroundImgActive = document.querySelector(".read--background__img._active");
					const backgroundImgCurrent = document.querySelector(".read--background__img_" + nextSlide.dataset.slideId);
					backgroundImgActive.classList.remove("_active");
					backgroundImgCurrent.classList.add("_active");
				},
				slideChangeTransitionStart: swiper => {
					const slide = swiper.slides[swiper.activeIndex] as HTMLElement;
					if (typeof slide.dataset.tabIndex !== "undefined") {
						this.setTab(slide.dataset.tabIndex)
					}
				}
			}
		})

		//slider.querySelector('.read--slider-btn__next').addEventListener('click', () => this.slideNext(desktop))
		//slider.querySelector('.read--slider-btn__prev').addEventListener('click', () => this.slidePrev(desktop))

		// mobile slider
		this.mobInstance = new Swiper(this.sliderMobContainer, {
			modules: [Navigation],
			loop: false,
			grabCursor: true,
			slidesPerView: "auto",
			spaceBetween: 50,
			navigation: {
				nextEl: document.querySelector(".read-slider-mob .read--slider-btn__next") as HTMLElement,
				prevEl: document.querySelector(".read-slider-mob .read--slider-btn__prev") as HTMLElement
			},
			breakpoints: {
				576: {
					spaceBetween: 120
				}
			},
			on: {
				afterInit: function () {
					if (window.outerWidth <= 1150) {
						let currentSlide;
						currentSlide = document.querySelector("#read .swiper-slide.swiper-slide-active");
						const backgroundImgCurrent = document.querySelector(".read--background__img_" + currentSlide.dataset.slideId);
						backgroundImgCurrent?.classList.add("_active");
					}
				},
				slideChange: function () {
					const currentSlide = this.slides[this.activeIndex];
					const backgroundImgActive = document.querySelector(".read--background__img._active");
					const backgroundImgCurrent = document.querySelector(".read--background__img_" + currentSlide.dataset.slideId);
					backgroundImgActive.classList.remove("_active");
					backgroundImgCurrent.classList.add("_active");
				},
				slideChangeTransitionStart: swiper => {
					const slide = swiper.slides[swiper.activeIndex] as HTMLElement;
					if (typeof slide.dataset.tabIndex !== "undefined") {
						this.setTab(slide.dataset.tabIndex)
					}
				}
			}
		})
	}

	slideNext(swiper) {

		swiper.slideNext();

		/* if ((swiper.activeIndex + 2) === (swiper.slides.length - 1)) {
			 let nextTabIndex = this.currentTabIndex + 1 > (this.tabs.length - 1) ? false : this.currentTabIndex + 1;
			 if (nextTabIndex !== false)
				 this.setTab(nextTabIndex);
		 } else {
			 swiper.slideNext();
		 }*/
	}

	slidePrev(swiper) {

		swiper.slidePrev();

		/*  if (swiper.activeIndex === 0) {
			  let prevTabIndex = this.currentTabIndex - 1 < 0 ? false : this.currentTabIndex - 1;
			  if (prevTabIndex !== false)
				  this.setTab(prevTabIndex);
		  } else {
			  swiper.slidePrev();
		  }*/
	}
}

export default ReadSlider;
